module.exports = __webpack_public_path__ + "static/media/Quam-Icon-Document.511d33a1.svg";